import React, { ReactNode, useContext, useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { DocumentContext } from '../../../contexts/DocumentContext';
import { Alert, Box, Button, CircularProgress, Grid, Modal, Paper, Snackbar, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { CustomerSummaryCard_V2 } from '../CustomerSummaryCard_V2';
import ProgressStepper from '../ProgressStepper';
import ContactCard from '../ContactCard';
import { checkIfIndividualCreditApp, convertToDate, getNested } from '../../../utils';
import { InvoiceEquipmentDetailsCard } from 'pages/VendorOpportunity/InvoiceEquipmentDetailsCard/InvoiceEquipmentDetailsCard';
import { connect, useDispatch, useSelector } from 'react-redux';
import { setRefetch, setValue } from '../../../redux/actions';
import LenderMatchingEngine from '../LenderMatchingEngine';
import DeliveryTimelineCard from '../DeliveryDetailCard';
import { VOChecklistCard } from '../VOChecklistCard';
import { CHAT_V2_SET_CREDIT_APP, CHAT_V2_TASKS, SET_CHAT_RESET } from '../../../redux/types';
import {
  Q_CREDIT_APP,
  Q_VENDOR_PROFILE,
  Q_VO,
  QUERY_ACTIVE_OCA_TEMPLATE,
  QUERY_PORTAL_CONFIGURATION,
} from '../../../queries/common';
import Agreements from '../Agreements';
import { portalConfigurationTypes } from '../../Prequal/constants';
import {
  assignFieldsOCAConfigFromActiveTemplate,
  isItemHasRestrictionForRole,
} from '../../../services/creditAppModalService';
import { getDefaultPortalConfigurationByType, rolesSettingsKeys } from '../../../services/pcwService';
import { CommonDataContext } from '../../../contexts/CommonDataContext';
import { theme } from '../../../theme';
import { LenderWaterfallResults } from '../LenderWaterfallResults';
import {
  AGREEMENTS,
  DOC_SETS,
  FETCH_INVENTORY_SEARCH_ACCESS,
  Q_EQUIPMENT,
  Q_INVOICE_DOC,
  Q_USER_DOCS,
  QUERY_TASKS,
  QUERY_VENDOR_PROFILES_ASSOCIATED_TO_LENDER,
  SEARCH_INVENTORY,
  START_FAST_TRACK_PROCESS,
  SYNC_INVENTORY,
} from './queres';
import { deliveryTimelineAPIKey, invoiceDetailAPIKey } from './constants';
import { VendorOpportunityTabs } from './types';
import { Breadcrumbs } from '../../../components/Breadcrumbs/Breadcrumbs';
import { VOSpecificTasks_V2 } from '../../../components/VOTaskList_V2/ui';
import { VODocuments_V2 } from '../../../components/VODocuments_V2';
import { CardContainer } from '../../../components/shared/CardContainer/CardContainer';
import { VendorLogoImg } from '../../../components/shared/VendorLogoImg';
import { VOSyndicationsList_V2 } from '../../../components/VOSyndicationsList_V2/ui';
import { BpfLinkType, DealActivityLinkType, LenderProfile, VendorContactRole } from '@trnsact/trnsact-shared-types';
import { TabsContainer } from '../../../components/shared/TabsContainer/TabsContainer';
import { CardBackground } from '../../../components/CardBackground/CardBackground';
import { ModalsKeys, Nullable, PageTypes, TabsOption } from 'global';
import { useViewTypeContext } from '../../../contexts/contentViewType';
import { portalConfigurationsSelectors } from '../../../redux/portalConfigurationReducer';
import { logError } from 'utils/logger';
import { useModal } from 'hooks/useModal';
import { useNotifications } from 'modules/notification';
import {
  collectVariablesForCreateProposal,
  deskingConfigByAccId,
  DeskingPanel,
  ProposalsTable,
  useCreateProposal,
} from 'modules/desking';
import { CreditApplicationDetailsFullView } from 'modules/creditApplicationDetails';
import { collectInvoiceFromVO, mapInvoiceFormValuesToQuote, useInvoice } from 'modules/invoice';
import { HealthCheckCard, InsuranceTab, ProfitVORevenueCard } from 'modules/vendorOpportunity';
import { useQuote } from 'modules/quote';
import { DeskingSubmitOptions, SaleType } from 'modules/desking/types';
import { AftermarketRevenueCard, useAftermarketProducts } from 'modules/aftermarket';
import { EquipmentRevenueCard, SyncDealInfo } from 'modules/equipment';
import { ModalsContainer } from 'components/shared/Modals';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import { DCR_API_BASE_SERVER_URL } from 'config';
import axios from 'axios';
import NewCreditAppModal from '../NewCreditAppModal';
import { CreditLineTab } from './tabs/CreditLineTab';
import { RevenueTab } from './tabs/revenue/RevenueTab';
import { getCcEmailOptions } from './lib';
import SyncDealInfoDialog from './SyncDealInfoDialog';
import { FundingCard } from 'modules/creditSubmission';
import { bpfAPI, ClosedDealInfo, StagesWidget } from 'modules/stages';
import { DealActivityCard } from 'modules/dealActivity';
import { Replay } from '@mui/icons-material';
import { useDealLifeCycle } from '../../../modules/stages/api/dealLifeCycle';

interface SettingsRouteState {
  proposalId?: string;
  initialTab?: VendorOpportunityTabs;
}

const doesDocumentTypeHaveRestrictionForRole = (
  documentTypeSettings: any,
  roleSettingKey: string,
  role: VendorContactRole
) => {
  const rolesRestriction = _.get(documentTypeSettings, ['rolesSettings', roleSettingKey]);
  return _.includes(rolesRestriction, role);
};

const PageOpportunityDetails = ({ reduxSetValue, account, vp, userProfile, refetch, setRefetch, chat }: any) => {
  const { contentViewType, isDesktop } = useViewTypeContext();
  const { showNotification } = useNotifications();
  const { push, replace } = useHistory();
  const { id: voId } = useParams<{ id: string }>();
  const { state: routerState } = useLocation<SettingsRouteState>();
  const { isProposalLoading, handleCreateProposal } = useCreateProposal();
  const { handleAftermarketProductCreate } = useAftermarketProducts();
  const { loading, actions } = useDealLifeCycle();

  const classes = useStyles();

  const dispatch = useDispatch();
  const creditSubmissionsData = useSelector((state: any) => state.creditSubmissions);
  const isUserHaveAccessToPrescreenResults = useSelector((state: any) =>
    portalConfigurationsSelectors.checkIfUserHaveAccessToPrescreenResults(state, userProfile)
  );
  const aftermarketPortalConfigurations = useSelector(portalConfigurationsSelectors.getAftermarket);

  const isUserHaveAccessToInventorySearch = useSelector(portalConfigurationsSelectors.checkAccessInventorySearch);

  const isUserHaveAccessToInvoiceAndEquipmentV2 = useSelector(
    portalConfigurationsSelectors.checkIfUserHaveAccessToInvoiceAndEquipmentV2
  );

  const voManagementPortalConfigurations = useSelector(portalConfigurationsSelectors.voManagementPortalConfigurations);

  const [isShowLegacyStages, setIsShowLegacyStages] = useState<boolean>(true);
  const [lastDocument, setLastDocument] = useState<any>();
  const [invoiceDoc, setInvoiceDoc] = useState<any>(false);
  const [userDocs, setUserDocs] = useState<any>(false);
  const [vendorProfile, setVendorProfile] = useState<any>();
  const [show, setShow] = useState<any>(false);
  const [vo, setVo] = useState<Nullable<any>>(null);
  const [applicationStage, setApplicationStage] = useState<any>('');
  const [invoiceStatus, setInvoiceStatus] = useState<any>('');
  const [dateString, setDateString] = useState<any>('');
  const [creditApp, setCreditApp] = useState<any>();
  const [ocaTemplateToUse, setOcaTemplateToUse] = useState<any>(null);
  const [isLegacyOCA, setIsLegacyOCA] = useState<boolean>(false);
  const [customerName, setCustomerName] = useState<any>('');
  const [invoiceDetailTableBody, setInvoiceDetailTableBody] = useState<any>([]);
  const [deliveryTimeLineTableBody, setDeliveryTimeLineTableBody] = useState<any>([]);
  const [handleSubmitToLenderByProfileId, setHandleSubmitToLenderByProfileId] = useState<any>(null);
  const [contactsTableBody, setContactsTableBody] = useState<any>([]);
  const [openDocSetModal, setOpenDocSetModal] = useState<any>(false);
  const [tasksLoading, setTasksLoading] = useState<any>(true);

  const [openEquipmentInputModal, setOpenEquipmentInputModal] = useState<any>(false);
  const [invoiceEquipmentTabPage, setInvoiceEquipmentTabPage] = useState<any>(0);
  const [fastTrackProcessStarted, setFastTrackProcessStarted] = useState<any>(false);
  const [fastTrackSnackBarClosed, setFastTrackSnackBarClosed] = useState<any>(false);
  const [CADMPortalConfiguration, setCADMPortalConfiguration] = useState<any>(null);
  const [portalConfigurationsByType, setPortalConfigurationsByType] = useState<any>();

  const [isScorecardHiddenForUserRole, setIsScorecardHiddenForUserRole] = useState<any>(true);
  const [isHealthCheckHiddenForUserRole, setIsHealthCheckHiddenForUserRole] = useState<any>(true);
  const [isCreditReportsHiddenForUserRole, setIsCreditReportsHiddenForUserRole] = useState<any>(true);
  const [isCreditReportDocumentsHiddenForUserRole, setIsCreditReportDocumentsHiddenForUserRole] = useState<any>(true);
  const [isCADMEditingDisabledForUserRole, setIsCADMEditingDisabledForUserRole] = useState<any>(true);
  const [isInsuranceHiddenForUserRole, setIsInsuranceHiddenForUserRole] = useState<any>(true);
  const [isVOChecklistHidden, setIsVOChecklistHidden] = useState<any>(true);

  const [isIndividualCreditApp, setIsIndividualCreditApp] = useState<boolean>(false);

  const [openLegacyCreditAppModal, setOpenLegacyCreditAppModal] = useState<boolean>(false);
  const [legacyPDFData, setLegacyPDFData] = useState<any>();

  const [vendorProfilesAssociatedToLender, setVendorProfilesAssociatedToLender] = useState<any>();
  const [voLoaded, setVoLoaded] = useState<any>(false);
  const [taskId, setTaskId] = useState<any>(null);
  const [creditAppOwners, setCreditAppContacts] = useState<any>(null);

  const [allConfigurationsLoaded, setAllConfigurationsLoaded] = useState(false);

  const [externalDealId, setExternalDealId] = useState<any>(null);

  const { isLenderUser, isSuperAdminOrSingleAccount } = useContext(CommonDataContext);

  const [searchInventory, { data: inventoryData, loading: inventoryDataIsLoading }] = useLazyQuery(SEARCH_INVENTORY, {
    fetchPolicy: 'no-cache',
  });
  const [syncInventory] = useMutation(SYNC_INVENTORY);

  const { loading: inventorySearchAccessLoading, data: inventorySearchAccessData } = useQuery(
    FETCH_INVENTORY_SEARCH_ACCESS,
    {
      fetchPolicy: 'no-cache',
      variables: {
        input: {
          integrationName: 'ARCADIUM',
          accountId: account.id,
        },
      },
    }
  );

  const { data: departmentsResponse } = useQuery(bpfAPI.department.fetchDepartmentsOptions);
  const isDepartmentsExist = departmentsResponse?.bpf?.result?.list?.length > 0;

  const handleExternalDealIdChange = (value: string) => {
    setExternalDealId(value);
  };

  const queryParams = new URLSearchParams(window.location.search);
  const startFastTrackProcessQueryParam = queryParams.get('startFastTrack');
  let startTaskId = queryParams.get('taskId');

  useEffect(() => {
    if (!voLoaded) reduxSetValue('vo', {});
    else setVoLoaded(false);
  }, [voLoaded]);

  const [startFastTrackProcess] = useLazyQuery(START_FAST_TRACK_PROCESS, {
    context: { authRequired: true },
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (startFastTrackProcessQueryParam === 'true' && !fastTrackProcessStarted) {
      setFastTrackProcessStarted(true);
      if (queryParams.has('startFastTrack')) {
        queryParams.delete('startFastTrack');
        replace({
          search: queryParams.toString(),
        });
      }
      const amountRequested = queryParams.get('amount');
      const equipmentType = queryParams.get('type');
      const equipmentHours = queryParams.get('hours');

      const fastTrackProcessInputs: any = {
        variables: {
          vendorOpportunityDatabaseId: voId,
        },
        context: { authRequired: true },
      };

      if (amountRequested || equipmentType || equipmentHours) {
        fastTrackProcessInputs.fastTrackInputs = {};
        if (amountRequested) {
          fastTrackProcessInputs.fastTrackInputs.amountRequested = amountRequested;
        }
        if (equipmentType) {
          fastTrackProcessInputs.fastTrackInputs.equipmentType = equipmentType;
        }
        if (equipmentHours) {
          fastTrackProcessInputs.fastTrackInputs.equipmentHours = equipmentHours;
        }
      }

      startFastTrackProcess(fastTrackProcessInputs);

      queryParams.delete('amount');
      queryParams.delete('type');
      queryParams.delete('hours');
      console.log('STARTING FAST TRACK PROCESS');
    }
  }, [account]);

  const handleOpenDocSetModal = () => {
    setOpenDocSetModal(true);
  };
  const handleCloseDocSetModal = () => {
    setOpenDocSetModal(false);
  };
  const onTasksLoaded = (loadedInfo: any) => {
    setTasksLoading(loadedInfo.loading);
    dispatch({ type: CHAT_V2_TASKS, payload: loadedInfo.tasks });
  };

  const [getVendorProfile, { data: vpData }] = useLazyQuery(Q_VENDOR_PROFILE, {
    context: { autRequired: true },
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
  });

  const [
    getVendorProfilesAssociatedToLender,
    { data: vendorProfilesAssociatedToLenderData, loading: loadingVendorProfilesAssociatedToLender },
  ] = useLazyQuery(QUERY_VENDOR_PROFILES_ASSOCIATED_TO_LENDER, {
    context: { autRequired: true },
    fetchPolicy: 'cache-and-network',
  });

  const { data: creditAppData, refetch: creditAppRefetch } = useQuery(Q_CREDIT_APP, {
    variables: {
      VOId: voId,
    },
    fetchPolicy: 'no-cache',
  });

  const { data: tasksData, refetch: refetchTasks } = useQuery(QUERY_TASKS, {
    variables: {
      VOId: voId,
      csId: null,
      limit: 100,
    },
    context: { authRequired: true },
    fetchPolicy: 'no-cache',
  });

  const [
    getPortalConfigurations,
    { data: portalConfigurationData, loading: portalConfigurationDataLoading, called: portalConfigurationDataCalled },
  ] = useLazyQuery(QUERY_PORTAL_CONFIGURATION, {
    context: { authRequired: true },
    fetchPolicy: 'no-cache',
  });

  const [
    getCADMPortalConfigurations,
    {
      data: CADMPortalConfigurationData,
      loading: CADMPortalConfigurationDataLoading,
      called: CADMPortalConfigurationDataCalled,
    },
  ] = useLazyQuery(QUERY_PORTAL_CONFIGURATION, {
    context: { authRequired: true },
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (
      portalConfigurationDataCalled &&
      CADMPortalConfigurationDataCalled &&
      !(portalConfigurationDataLoading || CADMPortalConfigurationDataLoading)
    ) {
      setAllConfigurationsLoaded(true);
    }
  }, [
    portalConfigurationDataCalled,
    CADMPortalConfigurationDataCalled,
    portalConfigurationDataLoading,
    CADMPortalConfigurationDataLoading,
  ]);

  const [getActiveOcaTemplate, { data: activeOCATemplateData }] = useLazyQuery(QUERY_ACTIVE_OCA_TEMPLATE, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (chat.targetVoId !== voId) {
      dispatch({ type: SET_CHAT_RESET });
    }

    creditAppRefetch();
    if (window) window.dispatchEvent(new CustomEvent('voUpdated', { detail: { updated: false } }));
  }, []);

  useEffect(() => {
    if (isLenderUser && _.some(account)) {
      getVendorProfilesAssociatedToLender({
        variables: {
          dynamicsAccountId: account.dynamicsAccountId,
        },
      });
    }
  }, [isLenderUser, account]);

  useEffect(() => {
    if (_.isEmpty(vendorProfilesAssociatedToLenderData)) {
      return;
    }
    setVendorProfilesAssociatedToLender(vendorProfilesAssociatedToLenderData.vendorProfilesByDynamicsLenderAccountId);
  }, [vendorProfilesAssociatedToLenderData]);

  const {
    data: userDocsData,
    refetch: userDocsRefetch,
    loading: userDocsLoading,
    error: userDocsError,
  } = useQuery(Q_USER_DOCS, {
    variables: {
      VOId: voId,
      docId: null,
    },
  });

  const { data: invoiceDocData, refetch: invoiceDocRefetch } = useQuery(Q_INVOICE_DOC, {
    variables: {
      VOId: voId,
    },
  });

  const { data: docSets } = useQuery(DOC_SETS, {
    variables: {
      accountId: account.id,
    },
  });

  const { data: agreements, refetch: agreementsRefetch } = useQuery(AGREEMENTS, {
    variables: {
      VOId: voId,
    },
  });

  const {
    data: equipmentData,
    refetch: equipmentDataRefetch,
    loading: equipmentLoading,
  } = useQuery(Q_EQUIPMENT, {
    variables: {
      VOId: voId,
    },
  });

  useEffect(() => {
    if (_.isEmpty(creditAppData?.creditApplication)) {
      return;
    }

    const { creditApplication } = creditAppData;

    dispatch({
      type: CHAT_V2_SET_CREDIT_APP,
      payload: creditApplication,
    });
    reduxSetValue('creditApp', creditApplication);
    setCreditApp(creditApplication);

    const currentCreditAppOcaTemplate = creditApplication.ocaTemplate;
    let vpIdToGetCADMPortalConfigurations;
    if (currentCreditAppOcaTemplate) {
      // Credit app could be submitted from both the lender's and dealer's templates
      vpIdToGetCADMPortalConfigurations = currentCreditAppOcaTemplate.vendorProfileId;
      setOcaTemplateToUse(currentCreditAppOcaTemplate);
      setIsLegacyOCA(false);
    } else {
      // For OCAv3, currentCreditAppOcaTemplate will be empty, so we want to use current active OCA template
      vpIdToGetCADMPortalConfigurations = account.vendorProfileId;
      getActiveOcaTemplate({
        variables: {
          vendorProfileId: account.vendorProfileId,
          isActive: true,
        },
      });
      setIsLegacyOCA(true);
    }

    getCADMPortalConfigurations({
      variables: {
        vendorProfileId: vpIdToGetCADMPortalConfigurations,
        types: [portalConfigurationTypes.CADMIndividual, portalConfigurationTypes.CADMCommercial],
      },
    });

    const creditAppContactsToSet = _([
      ...[creditApplication.primaryContact],
      ...(creditApplication.creditApplicationOwner ?? []),
    ])
      .compact()
      .uniqBy('ownerPgId')
      .value();
    setCreditAppContacts(creditAppContactsToSet);
  }, [creditAppData]);

  useEffect(() => {
    if (!!account && !!account.vendorProfileId) {
      if (!vpData) {
        getVendorProfile({
          variables: {
            id: account.vendorProfileId,
          },
          context: { authRequired: true },
        });
      }
    }
    if (vpData) {
      reduxSetValue('vp', vpData.vendorProfile);
      setVendorProfile(vpData.vendorProfile);

      const lenderProfiles = vpData.vendorProfile.lenderProfiles;
      setValue(
        'lp',
        lenderProfiles?.filter((lp: LenderProfile) => !lp.isDisabled)
      );
      setValue(
        'disabledLenderProfiles',
        lenderProfiles?.filter((lp: LenderProfile) => lp.isDisabled)
      );
    }

    if (startTaskId && document.getElementById('task-list')) {
      document?.getElementById('task-list')?.scrollIntoView({ behavior: 'smooth', block: 'center' });

      console.log('START TASK ID', startTaskId);

      setTimeout(() => {
        setTaskId(startTaskId);
      }, 1000);
      queryParams.delete('taskId');
      replace({
        search: queryParams.toString(),
      });
    }
  }, [getVendorProfile, account, vpData, reduxSetValue]);

  useEffect(() => {
    if (userDocsData !== null && userDocsData !== undefined && userDocsData.documents !== null) {
      setUserDocs(userDocsData);
    }
  }, [userDocsData]);

  useEffect(() => {
    if (invoiceDocData !== null && invoiceDocData !== undefined) {
      if (invoiceDocData.invoiceDoc && invoiceDocData.invoiceDoc.length) {
        const invoiceDocCopy = _.cloneDeep(invoiceDocData.invoiceDoc[0]);
        const date = invoiceDocCopy.createdDateTime;
        invoiceDocCopy.date = moment(date).format('ll hh:mma');
        setInvoiceDoc(invoiceDocCopy);
      } else {
        setInvoiceDoc(false);
      }
    }
  }, [invoiceDocData]);

  const refetchDocs = () => {
    userDocsRefetch();
    invoiceDocRefetch();
  };

  const BoldText = ({ text }: any) => {
    return <b>{text}</b>;
  };

  const [getVo, { data: voData, loading: voLoading, refetch: voRefetch, error: voError }] = useLazyQuery(Q_VO, {
    context: { authRequired: true },
    fetchPolicy: 'no-cache',
    variables: { voId },
  });

  useEffect(() => {
    if (isDepartmentsExist && voData?.vendorOpportunity?.businessProcessFlows?.flows?.some(Boolean)) {
      setIsShowLegacyStages(false);
    }
  }, [isDepartmentsExist, voData]);

  useEffect(() => {
    const parseTableData = ({ label, apiKey, format, checkIfExists }: any) => {
      const rowData = getNested(vo, apiKey);
      if (checkIfExists && (!rowData || parseInt(rowData) === 0)) {
        return undefined;
      }

      if (rowData) {
        if (format === 'upperCase') {
          let formattedString;
          if (rowData.includes('_')) {
            formattedString = vo[apiKey]
              .toLowerCase()
              .split('_')
              .map((s: any) => s.charAt(0).toUpperCase() + s.substring(1))
              .join(' ');
          } else {
            formattedString = rowData
              .toLowerCase()
              .split(' ')
              .map((s: any) => s.charAt(0).toUpperCase() + s.substring(1))
              .join(' ');
          }
          if (rowData.includes('delivered_pending_da')) {
            formattedString = 'Delivered (Pending Acceptance)';
          }
          if (rowData.includes('da_complete')) {
            formattedString = 'Customer Accepted';
          }
          return [label, formattedString];
        } else if (format === 'months') {
          const formattedString = (
            <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>{rowData} months</div>
          );
          return [label, formattedString];
        } else if (format === 'currency') {
          const formattedString = (
            <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
              {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(rowData)}
            </div>
          );
          return [label, formattedString];
        } else if (format === 'date') {
          let inputDate = new Date(rowData + 'T00:00:00');
          const getDay = inputDate.getDate();
          const getMonth = inputDate.getMonth() + 1; //Months are zero based
          const getYear = inputDate.getFullYear();
          const outputDate = getMonth + '-' + getDay + '-' + getYear;
          return [label, outputDate];
        } else {
          return [label, rowData];
        }
      } else {
        return [label, null];
      }
    };

    if (!!voData && !!voData.vendorOpportunity) {
      setVo(voData.vendorOpportunity);
      reduxSetValue('vo', vo);
      setVoLoaded(true);
      setTimeout(() => {
        if (window) window.dispatchEvent(new CustomEvent('voUpdated', { detail: { updated: true } }));
      }, 1000);
    } else {
      getVo();
    }

    if (!!vo && Object.keys(vo).length) {
      /*       const appStage =
        vo.applicationStage === "pre_qualified"
          ? "prequalified"
          : "dealer_cancelled"
          ? "dealer cancelled"
          : "customer_cancelled"
          ? "customer cancelled"
          : vo.applicationStage; */

      let appStage;
      switch (vo.applicationStage) {
        case 'pre_qualified':
          appStage = 'prequalified';
          break;
        case 'dealer_cancelled':
          appStage = 'dealer cancelled';
          break;
        case 'customer_cancelled':
          appStage = 'customer cancelled';
          break;
        default:
          appStage = vo.applicationStage;
      }

      setApplicationStage(appStage);
      setInvoiceStatus(vo.invoiceStatus);

      let invoiceDetailTableBodySource = invoiceDetailAPIKey.map(parseTableData).filter(i => i);
      console.log(invoiceDetailTableBodySource);

      invoiceDetailTableBodySource.forEach((item: any) => (item[0] = <BoldText text={item[0]} />));
      const deliveryTimeLineTableBodySource = deliveryTimelineAPIKey.map(i => parseTableData(i));
      deliveryTimeLineTableBodySource.forEach((item: any) => (item[0] = <BoldText text={item[0]} />));

      let contactsTableBodySource = [];

      contactsTableBodySource.push([
        <BoldText text="Sales Rep" />,
        vo?.salesRepresentative ? (
          <span
            style={{ color: theme.palette.primary.main, cursor: 'pointer' }}
            onClick={() => handleContactCardClick(vo?.salesRepresentative?.dynamicsContactId)}
          >
            {vo?.salesRepresentative?.fullName}
          </span>
        ) : (
          'N/A'
        ),
      ]);

      if (vo?.salesManager) {
        contactsTableBodySource.push([
          <BoldText text="Sales Manager" />,
          <span
            style={{ color: theme.palette.primary.main, cursor: 'pointer' }}
            onClick={() => handleContactCardClick(vo.salesManager ? vo.salesManager.dynamicsContactId : null)}
          >
            {vo.salesManager ? vo.salesManager.fullName : null}
          </span>,
        ]);
      }

      contactsTableBodySource.push([
        <BoldText text="Finance Manager" />,
        vo?.financeManager ? (
          <span
            style={{ color: theme.palette.primary.main, cursor: 'pointer' }}
            onClick={() => handleContactCardClick(vo.financeManager.dynamicsContactId)}
          >
            {vo.financeManager.fullName}
          </span>
        ) : (
          'N/A'
        ),
      ]);

      const handleContactCardClick = (id: any) => {
        if (!id) return;
        push(`/profile/${id}`);
      };
      contactsTableBodySource.forEach(item => (item[0] = <BoldText onClick={handleContactCardClick} text={item[0]} />));
      setContactsTableBody([...contactsTableBodySource]);

      const createdOn = new Date(Date.parse(vo.createdOn));
      setDateString(convertToDate(createdOn));
      setCustomerName(_.get(vo, 'potentialCustomer.name', ''));
      setInvoiceDetailTableBody(invoiceDetailTableBodySource);
      setDeliveryTimeLineTableBody(deliveryTimeLineTableBodySource);
      setContactsTableBody(contactsTableBodySource);
      try {
        setExternalDealId(vo.externalCrmVendorOpportunity[0].externalId);
      } catch (e) {
        console.log('Error Setting external Deal ID', e);
      }

      setShow(true);
    }
  }, [getVo, voData, vo, reduxSetValue]);

  useEffect(() => {
    if (
      _.some(equipmentData?.equipments) &&
      ((invoiceDetailTableBody[0] && invoiceDetailTableBody[0][0]?.props.text === 'Equipment Cost (Subtotal)') ||
        (invoiceDetailTableBody[1] && invoiceDetailTableBody[1][0]?.props.text === 'Equipment Cost (Subtotal)'))
    ) {
      let equipmentsInvoiceTable = [...invoiceDetailTableBody];
      const index = equipmentsInvoiceTable.findIndex(i => i[0].props.text === 'Equipment Cost (Subtotal)');
      equipmentsInvoiceTable = equipmentsInvoiceTable.filter(i => i[0].props.text !== 'Equipment Cost (Subtotal)');

      equipmentData.equipments.forEach((equipment: any) => {
        const title = `${equipment.year} ${equipment.make} ${equipment.model}${
          equipment.quantity > 1 ? ' (Qty: ' + equipment.quantity + ')' : ''
        }`;
        equipmentsInvoiceTable.splice(index, 0, [
          <BoldText text={title} />,
          <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
            {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(equipment.retailPrice)}
          </div>,
        ]);
      });
      setInvoiceDetailTableBody(equipmentsInvoiceTable);
    }
  }, [equipmentData, invoiceDetailTableBody]);

  useEffect(() => {
    const vendorProfileId = _.get(account, 'vendorProfileId');
    if (!vendorProfileId) {
      return;
    }

    getPortalConfigurations({
      variables: {
        vendorProfileId,
        types: [
          portalConfigurationTypes.scorecard,
          portalConfigurationTypes.healthCheck,
          portalConfigurationTypes.creditReports,
          portalConfigurationTypes.documents,
          portalConfigurationTypes.voManagement,
          portalConfigurationTypes.voChecklistTemplate,
          portalConfigurationTypes.insurance,
        ],
      },
    });
  }, [account]);

  useEffect(() => {
    if (_.isEmpty(activeOCATemplateData) || !!ocaTemplateToUse) {
      return;
    }
    setOcaTemplateToUse(_.first(activeOCATemplateData.getOcaTemplatesByVendorProfile));
  }, [activeOCATemplateData]);

  useEffect(() => {
    if (!CADMPortalConfigurationData || !creditAppData || !ocaTemplateToUse) {
      return;
    }
    const applicationType = _.get(creditAppData, 'creditApplication.applicationType');
    const portalConfigurations = _.get(CADMPortalConfigurationData, 'portalConfigurations') || [];
    const isIndividualCreditApp = checkIfIndividualCreditApp(applicationType);
    const CADMConfigurationTypeToUse = isIndividualCreditApp
      ? portalConfigurationTypes.CADMIndividual
      : portalConfigurationTypes.CADMCommercial;
    const CADMConfigurationToUse = _.find(portalConfigurations, { type: CADMConfigurationTypeToUse });
    if (_.some(CADMConfigurationToUse)) {
      assignFieldsOCAConfigFromActiveTemplate(CADMConfigurationToUse.jsonDefinition, ocaTemplateToUse.jsonDefinition);
    }
    setCADMPortalConfiguration(CADMConfigurationToUse);
    setIsIndividualCreditApp(isIndividualCreditApp);
  }, [CADMPortalConfigurationData, creditAppData, ocaTemplateToUse]);

  useEffect(() => {
    if (!portalConfigurationData || !creditAppData) {
      return;
    }
    const portalConfigurations = _.get(portalConfigurationData, 'portalConfigurations') || [];
    const portalConfigurationsToSetByDefault = [
      portalConfigurationTypes.documents,
      portalConfigurationTypes.voChecklistTemplate,
      portalConfigurationTypes.insurance,
      portalConfigurationTypes.scorecard,
    ];

    _.forEach(portalConfigurationsToSetByDefault, portalConfigurationType => {
      if (!_.find(portalConfigurations, { type: portalConfigurationType })) {
        portalConfigurations.push(
          getDefaultPortalConfigurationByType(portalConfigurationType, account.vendorProfileId)
        );
      }
    });
    setPortalConfigurationsByType(_.keyBy(portalConfigurations, 'type'));
  }, [portalConfigurationData, creditAppData]);

  useEffect(() => {
    if (_.isEmpty(portalConfigurationsByType)) {
      return;
    }

    const isHealthCheckHiddenForUserRole = isItemHasRestrictionForRole(
      _.get(portalConfigurationsByType, `${portalConfigurationTypes.healthCheck}.jsonDefinition`),
      rolesSettingsKeys.hidden,
      userProfile.vendorContactRole
    );

    const isCreditReportsHiddenForUserRole = isItemHasRestrictionForRole(
      _.get(portalConfigurationsByType, `${portalConfigurationTypes.creditReports}.jsonDefinition`),
      rolesSettingsKeys.hidden,
      userProfile.vendorContactRole
    );

    // Check if credit_report documents are hidden based on Documents portal configuration
    const documentsConfig = _.get(portalConfigurationsByType, `${portalConfigurationTypes.documents}.jsonDefinition`);
    const documentsByTypeSettings = _.get(documentsConfig, 'config.documentsByTypeSettings', {});
    const creditReportDocumentSettings = _.get(documentsByTypeSettings, 'credit_report', {});
    const isCreditReportDocumentsHiddenForUserRole = doesDocumentTypeHaveRestrictionForRole(
      creditReportDocumentSettings,
      rolesSettingsKeys.hidden,
      userProfile.vendorContactRole
    );

    const isCADMEditingDisabled = isItemHasRestrictionForRole(
      _.get(portalConfigurationsByType, `${portalConfigurationTypes.voManagement}.jsonDefinition`),
      rolesSettingsKeys.cadmReadOnly,
      userProfile.vendorContactRole
    );

    const isVOChecklistHidden =
      _.get(
        portalConfigurationsByType,
        `${portalConfigurationTypes.voChecklistTemplate}.jsonDefinition.config.hidden`
      ) === true;

    const isInsuranceHiddenForUserRole = isItemHasRestrictionForRole(
      _.get(portalConfigurationsByType, `${portalConfigurationTypes.insurance}.jsonDefinition`),
      rolesSettingsKeys.hidden,
      userProfile.vendorContactRole
    );

    const scorecardUserRolesHidden = isItemHasRestrictionForRole(
      _.get(portalConfigurationsByType, `${portalConfigurationTypes.scorecard}.jsonDefinition`),
      rolesSettingsKeys.reportsHidden,
      userProfile.vendorContactRole
    );

    setIsHealthCheckHiddenForUserRole(isHealthCheckHiddenForUserRole);
    setIsCreditReportsHiddenForUserRole(isCreditReportsHiddenForUserRole);
    setIsCreditReportDocumentsHiddenForUserRole(isCreditReportDocumentsHiddenForUserRole);
    setIsCADMEditingDisabledForUserRole(isCADMEditingDisabled);
    setIsVOChecklistHidden(isVOChecklistHidden);
    setIsInsuranceHiddenForUserRole(isInsuranceHiddenForUserRole);
    setIsScorecardHiddenForUserRole(scorecardUserRolesHidden);
  }, [portalConfigurationsByType]);

  useEffect(() => {
    console.log(`Executing submit to ${handleSubmitToLenderByProfileId}`);
  }, [handleSubmitToLenderByProfileId]);

  if (refetch.vo) {
    setRefetch('vo', false);
    voRefetch();
  }

  if (refetch.creditApp) {
    setRefetch('creditApp', false);
    creditAppRefetch();
  }

  let showHealthCheck = false;

  if (vendorProfile && vendorProfile.ofacRedFlagComplianceAccess) {
    showHealthCheck = true;
  }

  const isCashSale = vo?.entityType === 'CASH_SALE';

  const callbackSubmissionFinished = (dynamicsCreditSubmissionId: any) => {
    console.log(`Finished submission with ID ${dynamicsCreditSubmissionId}`);
    //Send mutation to update Lender Waterfall
    setHandleSubmitToLenderByProfileId(null);
  };

  const handleSubmitLenderWaterfall = (profileId: string) => {
    setHandleSubmitToLenderByProfileId(profileId);
  };

  const handleLegacyCreditAppRequest = async () => {
    const url = `${DCR_API_BASE_SERVER_URL}/create-pdf?transaction_id=${vo.transactionId}`;
    const data = {
      vendorProfile,
      account: { account, userProfile },
      userProfile: userProfile,
      download: false,
    };
    const config: any = {
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/html',
      },
    };
    return axios
      .post(url, data, config)
      .then(response => {
        setLegacyPDFData(response.data);
        setOpenLegacyCreditAppModal(true);
      })
      .catch(error => console.log(error));
  };

  // Submissions tab

  const isDataExist = !!vp && !!userProfile;
  const isSubmiossionsAvailableForCurrentUserRole = [
    VendorContactRole.CreditMgr,
    VendorContactRole.SalesMgr,
    VendorContactRole.Admin,
    VendorContactRole.Executive,
  ].includes(userProfile.vendorContactRole);

  const isVPAccessExistForAll = vp.showLenderSubmission === 'all_roles_full_access';

  const isCreditMgrAndVPAccessExist =
    vp.showLenderSubmission === 'credit_manager_only' && userProfile.vendorContactRole === VendorContactRole.CreditMgr;

  const isRenderSubmissionsTab =
    (isDataExist && !isCashSale && vp.showLenderSubmission === 'all_roles') ||
    isVPAccessExistForAll ||
    isCreditMgrAndVPAccessExist ||
    (vp.showLenderSubmission === 'all_managers' && isSubmiossionsAvailableForCurrentUserRole && !_.isEmpty(creditApp));

  const [pageContentViewType, setPageContentViewType] = useState<'full' | 'details'>('full');

  const { handleUpdateInvoice, isInvoiceUpdating } = useInvoice();
  const { handleCreateOrUpdateQuote } = useQuote();
  const { handleOpen: handleOpenConfirmationModal } = useModal(ModalsKeys.Confirmation);
  const { handleOpen: handleOpenUpdateInvoiceModal } = useModal(ModalsKeys.CreateUpdateInvoiceDialog);
  const { handleOpen: handleOpenDeskingConfirmModal } = useModal(ModalsKeys.DeskingConfirmSaveDraftDialog);

  const updateInvoice = () => {
    handleOpenUpdateInvoiceModal({
      invoice: collectInvoiceFromVO(vo),
      onSubmit: async invoiceFormValues => {
        try {
          const { netTrade, netFinanceAmount, downPayment, ...fieldsObj } = invoiceFormValues;
          const { vendorOpportunityId: VOId, dynamicsVendorOpportunityId: entityId } = vo;
          const quoteInput = mapInvoiceFormValuesToQuote(invoiceFormValues);

          await handleUpdateInvoice({ fieldsObj: { downPayment: downPayment.flat, ...fieldsObj }, VOId, entityId });
          await handleCreateOrUpdateQuote(VOId, quoteInput);
          await voRefetch();

          showNotification('Invoice updated!');
        } catch (error) {
          logError(error);
          showNotification('Invoice not updated!', { type: 'error' });
        }
      },
    });
  };

  const showCreditLineCard =
    creditApp?.applyingFor?.includes('creditLine') || creditApp?.creditLineAmountRequested !== null;

  const isRenderCreditLineTab =
    showCreditLineCard ||
    vp.showDocMgt === 2 ||
    vp.showTasks === 'show' ||
    (showHealthCheck && creditApp?.creditApplicationOwner?.length > 0 && !isHealthCheckHiddenForUserRole);

  const isAccessToSubmissionsTabProvidedOnPortalSetup =
    !voManagementPortalConfigurations.submissionsTabHiddenFor?.includes(userProfile.vendorContactRole);

  const handleSubmitDesking = async ({
    form,
    isDraft,
    pricing,
    builder,
    onDeskingReset,
    parentProposalId,
    productsConfigInMenu,
    commonProductsConfiguration,
  }: DeskingSubmitOptions) => {
    try {
      if (!vo?.vendorOpportunityId) return;

      if (!form.financeQuote.terms.length && form.saleDetails.saleType !== SaleType.Cash) {
        showNotification('Terms required', { type: 'error' });
        return;
      }

      const variables = collectVariablesForCreateProposal({
        isDraft,
        pricing,
        formData: form,
        menuByTerms: builder,
        parentProposalId,
        productsConfigInMenu,
        commonProductsConfiguration,
        voId: vo.vendorOpportunityId,
      });

      if (isDraft) {
        handleOpenDeskingConfirmModal({
          onSaveAsDraft: () => handleCreateProposal(variables, onDeskingReset),
        });
      } else await handleCreateProposal(variables, onDeskingReset);
    } catch (error) {
      logError(error);
    }
  };

  console.log({ isShowLegacyStages });

  const tabs: TabsOption<VendorOpportunityTabs>[] = [
    {
      label: 'General',
      value: VendorOpportunityTabs.General,
      isVisible: true,
      component: (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <RenderWithCondition
              condition={isShowLegacyStages}
              fallBack={
                <StagesWidget
                  accountId={account.id}
                  parentType={BpfLinkType.Vo}
                  parentCreatedAt={vo?.createdOn}
                  parentId={vo?.vendorOpportunityId}
                  dealPaymentType={vo?.paymentType}
                  isDealClosed={vo?.closeInfo?.isClosed ?? false}
                  closedStatus={vo?.closeInfo?.closeDealStatus ?? null}
                  closeReasonId={vo?.closeInfo?.reasonId ?? null}
                  onSwitchToLegacyStages={() => {
                    setIsShowLegacyStages(true);
                  }}
                />
              }
            >
              <ProgressStepper
                isNewStagesExist={!!vo?.businessProcessFlows?.flows?.some(Boolean)}
                onSwitchToNewStages={() => {
                  setIsShowLegacyStages(false);
                }}
              />
            </RenderWithCondition>
          </Grid>

          <Grid item sm={12} md={6} style={{ width: '100%' }}>
            <CustomerSummaryCard_V2
              goToCADView={() => {
                setPageContentViewType('details');
              }}
              contentViewType={contentViewType}
              vo={vo}
              refetchVO={voRefetch}
              equipmentData={equipmentData}
              refetchEquipment={equipmentDataRefetch}
              equipmentLoading={equipmentLoading}
              invoiceEquipmentTabPage={invoiceEquipmentTabPage}
              creditApplication={creditApp}
              vp={vendorProfile}
              userProfile={userProfile}
              account={account}
              refetchCreditApp={creditAppRefetch}
              userDocs={userDocs}
              userDocsRefetch={userDocsRefetch}
              isIndividualCreditApp={isIndividualCreditApp}
              tasksData={tasksData}
              portalConfigurationDataLoading={portalConfigurationDataLoading || CADMPortalConfigurationDataLoading}
              isCreditReportsHiddenForUserRole={isCreditReportsHiddenForUserRole}
              isCreditReportDocumentsHiddenForUserRole={isCreditReportDocumentsHiddenForUserRole}
              isCreditAppNeedsRecertification={creditApp?.needsRecertification}
              creditAppOwners={creditAppOwners}
              refetchDocs={refetchDocs}
              ocaTemplate={ocaTemplateToUse}
              inventoryActions={{
                searchInventory,
                inventoryData,
                inventoryDataIsLoading,
                syncInventory,
                inventorySearchAccessData,
                inventorySearchAccessLoading,
                hasAccessToInventorySearch: isUserHaveAccessToInventorySearch,
              }}
            />
          </Grid>

          {!!account && !!vo && (
            <Grid item sm={12} md={6} style={{ width: '100%' }}>
              <InvoiceEquipmentDetailsCard
                vo={vo}
                account={account}
                vendorProfile={vp}
                isUserHaveAccessToInvoiceAndEquipmentV2={isUserHaveAccessToInvoiceAndEquipmentV2}
                creditApp={creditApp}
                refetchVO={voRefetch}
                invoiceDoc={invoiceDoc}
                updateInvoice={updateInvoice}
                equipmentData={equipmentData}
                invoiceStatus={invoiceStatus}
                refetchDocs={() => refetchDocs()}
                refetchCreditApp={creditAppRefetch}
                refetchEquipment={equipmentDataRefetch}
                openEquipmentInputModal={openEquipmentInputModal}
                isInvoiceUpdating={voLoading || isInvoiceUpdating}
                setOpenEquipmentInputModal={setOpenEquipmentInputModal}
                vendorProfilesAssociatedToLender={vendorProfilesAssociatedToLender}
                loadingVendorProfilesAssociatedToLender={loadingVendorProfilesAssociatedToLender}
                inventoryActions={{
                  searchInventory,
                  inventoryData,
                  inventoryDataIsLoading,
                  syncInventory,
                  inventorySearchAccessData,
                  inventorySearchAccessLoading,
                  hasAccessToInventorySearch: isUserHaveAccessToInventorySearch,
                }}
              />
            </Grid>
          )}

          {showHealthCheck && creditApp?.creditApplicationOwner?.length > 0 && !isHealthCheckHiddenForUserRole && (
            <Grid item xs={12}>
              <HealthCheckCard
                creditApp={creditApp}
                accountId={account.id}
                full={!showCreditLineCard}
                userName={userProfile.fullName}
                refetchCreditApp={creditAppRefetch}
                softPullInDealerPortal={vendorProfile.softPullInDealerPortal}
              />
            </Grid>
          )}

          {!vp ? (
            <Grid item xs={12}>
              no VendorProfile loaded
            </Grid>
          ) : vp.dcrPrescreenStatus === '804790001' ||
            vp.dcrPrescreenStatus === '804790002' ||
            vp.dcrPrescreenStatus === '804790003' ? (
            <Grid item xs={12}>
              <LenderMatchingEngine />
            </Grid>
          ) : (
            <div />
          )}

          {!!account && !!vo && (
            <Grid item xs={12} md={6}>
              <DeliveryTimelineCard
                vo={vo}
                refetchVO={voRefetch}
                contentViewType={contentViewType}
                deliveryTimeLineTableBody={deliveryTimeLineTableBody}
              />
            </Grid>
          )}

          {!!account && !!vo && !!vo?.potentialCustomer && (
            <Grid item xs={12} md={6}>
              <ContactCard
                vo={vo}
                refetchVO={voRefetch}
                creditApp={creditApp}
                contentViewType={contentViewType}
                contactsTableBody={contactsTableBody}
                setContactsTableBody={setContactsTableBody}
                multiLocationManagement={vp.multiLocationManagement}
              />
            </Grid>
          )}

          <Snackbar
            autoHideDuration={null}
            onClose={() => setFastTrackSnackBarClosed(true)}
            open={fastTrackProcessStarted && !fastTrackSnackBarClosed}
            anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
          >
            <Alert elevation={6} color="success" variant="filled">
              This deal has been fast tracked! Check your email periodically for updates!
            </Alert>
          </Snackbar>

          {/*  REMOVED BY DR-8663
              <RenderWithCondition condition={vp?.showNotes}>
            <Grid item xs={12}>
              <NotesCard vo={vo} userProfile={userProfile} />
            </Grid>
          </RenderWithCondition> */}

          {vp.docusignDocMgmt === 'show' &&
            (vo?.applicationStage === 'approved' || vo?.applicationStage === 'pre-approved') && (
              <Grid item xs={12}>
                <Agreements
                  vo={vo}
                  handleOpen={handleOpenDocSetModal}
                  agreementsRefetch={agreementsRefetch}
                  agreements={agreements ? agreements.agreements : null}
                />
              </Grid>
            )}

          {!vp ? 'no VendorProfile loaded' : !!vp && vp.showChat === 'show' ? null : null}

          <Grid item xs={12}>
            <DealActivityCard parentId={vo?.vendorOpportunityId} parentType={DealActivityLinkType.Vo} />
          </Grid>
        </Grid>
      ),
      urlAnchor: '#general',
    },
    {
      label: 'Credit Line',
      isVisible: isRenderCreditLineTab,
      value: VendorOpportunityTabs.CreditLine,
      component: (
        <CreditLineTab
          vo={vo}
          creditApp={creditApp}
          accountId={account.id}
          vendorProfile={vendorProfile}
          userName={userProfile.fullName}
          creditAppRefetch={creditAppRefetch}
          contentViewType={contentViewType}
          refetchVO={voRefetch}
          equipmentData={equipmentData}
          refetchEquipment={equipmentDataRefetch}
          equipmentLoading={equipmentLoading}
          userProfile={userProfile}
          account={account}
          portalConfigurationDataLoading={portalConfigurationDataLoading || CADMPortalConfigurationDataLoading}
          creditAppOwners={creditAppOwners}
          isScorecardHiddenForUserRole={isScorecardHiddenForUserRole}
          showCreditLineCard={showCreditLineCard}
          permissions={{
            docs: vp.showDocMgt === 2,
            creditLine: showCreditLineCard,
            tasks: vp.showTasks === 'show',
            healthCheck:
              showHealthCheck && creditApp?.creditApplicationOwner?.length > 0 && !isHealthCheckHiddenForUserRole,
          }}
        />
      ),
      urlAnchor: '#creditLine',
    },
    {
      label: 'Insurance',
      isVisible: isSuperAdminOrSingleAccount || !isInsuranceHiddenForUserRole,
      value: VendorOpportunityTabs.Insurance,
      component: <InsuranceTab vo={vo} creditApp={creditApp} />,
    },
    {
      label: 'Tasks',
      value: VendorOpportunityTabs.Tasks,
      isVisible: true,
      component: (
        <>
          {!vp ? (
            <div id="task-list"></div>
          ) : (
            vp.showTasks === 'show' && (
              <Grid item xs={12}>
                <div id="task-list">
                  <VOSpecificTasks_V2
                    vo={vo}
                    taskId={taskId}
                    conversations={null}
                    refetchConversations={() => {}}
                    conversationsLoading={false}
                    voId={voId}
                    account={account}
                    userProfile={userProfile}
                    onTasksLoaded={onTasksLoaded}
                    handleConversationCreation={() => {}}
                    documents={userDocs?.documents}
                    documentsPortalConfiguration={_.get(portalConfigurationsByType, portalConfigurationTypes.documents)}
                    refetchDocs={refetchDocs}
                  />
                </div>
              </Grid>
            )
          )}

          {vo && !isVOChecklistHidden && (
            <Grid item xs={12}>
              <VOChecklistCard voId={vo?.vendorOpportunityId} voChecklist={vo?.checklist} refetchVO={voRefetch} />
            </Grid>
          )}
        </>
      ),
      urlAnchor: '#tasks',
    },
    {
      label: 'Documents',
      value: VendorOpportunityTabs.Documents,
      isVisible: true,
      component: allConfigurationsLoaded ? (
        <Grid item xs={12}>
          {!!vp && vp.showDocMgt === 2 && (
            <VODocuments_V2
              vo={vo}
              userDocs={userDocs}
              tasksData={tasksData}
              refetchDocs={refetchDocs}
              userDocsError={userDocsError}
              creditAppOwners={creditAppOwners}
              userDocsLoading={userDocsLoading}
              refetchCreditApp={creditAppRefetch}
              CADMPortalConfiguration={CADMPortalConfiguration}
              showDcrCreditAppRow={vo?.transactionStage !== 'Lead'}
              isCADMEditingDisabled={isCADMEditingDisabledForUserRole}
              documentsPortalConfiguration={_.get(portalConfigurationsByType, portalConfigurationTypes.documents)}
              portalConfigurationDataLoading={portalConfigurationDataLoading || CADMPortalConfigurationDataLoading}
            />
          )}
        </Grid>
      ) : (
        <CircularProgress />
      ),
      urlAnchor: '#documents',
    },
    {
      label: 'Submissions',
      value: VendorOpportunityTabs.Submissions,
      isVisible: voManagementPortalConfigurations.submissionsTabHiddenFor?.length
        ? isAccessToSubmissionsTabProvidedOnPortalSetup
        : isRenderSubmissionsTab,
      component: (
        <Grid container spacing={1}>
          {isUserHaveAccessToPrescreenResults && (
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <LenderWaterfallResults
                accountId={account.id}
                vendorOpportunityId={voId}
                lenderProfiles={vp.lenderProfiles}
                creditSubmissions={creditSubmissionsData}
                handleSubmitToLenderByProfileId={handleSubmitLenderWaterfall}
              />
            </Grid>
          )}

          {isDataExist ? (
            vp.showLenderSubmission === 'all_roles' ||
            vp.showLenderSubmission === 'all_roles_full_access' ||
            (vp.showLenderSubmission === 'credit_manager_only' &&
              userProfile.vendorContactRole === VendorContactRole.CreditMgr) ||
            (vp.showLenderSubmission === 'all_managers' && isSubmiossionsAvailableForCurrentUserRole) ? (
              <>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  {!_.isEmpty(creditApp) ? (
                    <VOSyndicationsList_V2
                      setInvoiceEquipmentTabPage={setInvoiceEquipmentTabPage}
                      equipmentData={equipmentData}
                      setOpenEquipmentInputModal={setOpenEquipmentInputModal}
                      portalConfiguration={CADMPortalConfiguration}
                      handleSubmitToLenderByProfileId={handleSubmitToLenderByProfileId}
                      callbackSubmissionFinished={callbackSubmissionFinished}
                    />
                  ) : null}
                </Grid>
              </>
            ) : (
              <></>
            )
          ) : (
            <></>
          )}
        </Grid>
      ),
    },
    {
      label: 'Desking',
      disabled: !creditAppData,
      value: VendorOpportunityTabs.Desking,
      isVisible: !voManagementPortalConfigurations.deskingTabHiddenFor?.includes(userProfile.vendorContactRole),
      component: (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            {!!creditAppData && (
              <CardContainer>
                <DeskingPanel
                  vo={vo}
                  accountId={account.id}
                  userEmail={userProfile.email}
                  invoice={collectInvoiceFromVO(vo)}
                  proposalId={routerState?.proposalId || queryParams.get('proposalId')}
                  isProposalLoading={isProposalLoading}
                  onSubmitDesking={handleSubmitDesking}
                  creditApplication={creditAppData?.creditApplication}
                  onCreateProposalProduct={handleAftermarketProductCreate}
                  configurationByAccount={deskingConfigByAccId[account.id]}
                  isProductCreationAvailable={aftermarketPortalConfigurations?.allowCreateCustomProducts}
                  allAvailableCcEmailOptions={getCcEmailOptions(vo, creditAppData?.creditApplication, account.contacts)}
                  invoiceAction={
                    <Button size="small" variant="contained" disabled={isInvoiceUpdating} onClick={updateInvoice}>
                      {isInvoiceUpdating ? 'Updating' : 'Edit'}
                    </Button>
                  }
                  actions={{
                    onEquipmentCreated: async () => {
                      showNotification('Equipment created!');
                      await voRefetch();
                    },
                    onEquipmentUpdated: async () => {
                      showNotification('Equipment updated!');
                      await voRefetch();
                    },
                    onEquipmentRemoved: async () => {
                      showNotification('Equipment Removed!');
                      await voRefetch();
                    },
                  }}
                  inventoryActions={{
                    searchInventory,
                    inventoryData,
                    inventoryDataIsLoading,
                    syncInventory,
                    inventorySearchAccessData,
                    inventorySearchAccessLoading,
                    hasAccessToInventorySearch: isUserHaveAccessToInventorySearch,
                  }}
                />
              </CardContainer>
            )}
          </Grid>

          <Grid item xs={12}>
            <ProposalsTable vendorGUID={account.dynamicsAccountId} voId={voId} />
          </Grid>
        </Grid>
      ),
      urlAnchor: '#desking',
    },
    {
      label: 'Revenue',
      value: VendorOpportunityTabs.Revenue,
      urlAnchor: '#revenue',
      isVisible: true,
      component: (
        <RevenueTab
          accountId={account.id}
          voId={vo?.vendorOpportunityId}
          dynamicsVOId={vo?.dynamicsVendorOpportunityId}
          submissionCard={props => <FundingCard {...props} />}
          profitCard={props => <ProfitVORevenueCard {...props} />}
          equipmentCard={props => <EquipmentRevenueCard {...props} />}
          aftermarketCard={props => <AftermarketRevenueCard {...props} />}
        />
      ),
    },
  ];

  const render = {
    full: (
      <>
        {show ? (
          <DocumentContext.Provider value={{ lastDoc: lastDocument, documents: [], setLastDocument }}>
            <Box className={classes.pageContainer}>
              <Paper className={classes.head} elevation={0}>
                <Box className={classes.headContent}>
                  <Box className={classes.header}>
                    <Typography variant="h5" component="div">
                      Opportunity Details: {creditAppData?.creditApplication?.businessName}
                    </Typography>

                    <SyncDealInfo
                      externalDealId={externalDealId}
                      onExternalDealIdChange={handleExternalDealIdChange}
                      isUserHaveAccessToInventorySearch={isUserHaveAccessToInventorySearch}
                    />

                    {!!vo?.closeInfo && (
                      <ClosedDealInfo
                        {...vo.closeInfo}
                        reopenAction={
                          <Button
                            size="small"
                            variant="contained"
                            startIcon={<Replay />}
                            loading={loading.isDealReopening}
                            onClick={() =>
                              handleOpenConfirmationModal({
                                title: 'Confirmation',
                                message: 'Do you really want to reopen the deal?',
                                onConfirm: () =>
                                  actions.handleReopenDeal(
                                    { parentId: vo.vendorOpportunityId, parentType: BpfLinkType.Vo },
                                    () => ({ refetchQueries: [Q_VO], awaitRefetchQueries: true })
                                  ),
                              })
                            }
                          >
                            Reopen Deal
                          </Button>
                        }
                      />
                    )}
                  </Box>

                  {isDesktop && (
                    <Breadcrumbs
                      currentValue="Detail"
                      config={[
                        { label: 'Opportunity View', value: 'list', onClick: () => push('/vo') },
                        { label: 'Detail', value: 'Detail', onClick: () => {} },
                      ]}
                    />
                  )}
                </Box>

                {vo?.partnerLogo && <VendorLogoImg partnerLogo={vo.partnerLogo} />}
              </Paper>

              <TabsContainer<VendorOpportunityTabs>
                tabs={tabs}
                isSyncWithAnchor
                TabsLabelWrapper={CardBackground}
                contentViewType={contentViewType}
              />
            </Box>

            {!vp && 'no VendorProfile loaded'}
          </DocumentContext.Provider>
        ) : (
          <>
            {voLoading && <CircularProgress />}
            {voError && <>Loading Error...</>}
          </>
        )}
      </>
    ),
    details: (
      <CreditApplicationDetailsFullView
        backToCommonView={() => {
          setPageContentViewType('full');
        }}
        creditApplicationState={{
          vo,
          account,
          isLegacyOCA,
          refetchTasks,
          equipmentData,
          vendorProfile: vp,
          refetchVO: voRefetch,
          pageType: PageTypes.VendorOpportunities,
          refetchCreditAppOuter: creditAppRefetch,
          isEditingDisabled: isCADMEditingDisabledForUserRole,
          vendorOpportunityTasks: tasksData?.vendorOpportunityTask,
          creditAppModalConfig: CADMPortalConfiguration?.jsonDefinition,
          isCreditAppNeedsRecertification: creditAppData?.creditApplication?.needsRecertification,
          creditAppOwners: creditAppOwners,
          applicant: creditAppData?.creditApplication?.businessName || vo?.potentialCustomer?.name,
          handleLegacyCreditAppRequest,
        }}
      />
    ),
  };

  // TODO: Need to move ---> PageOpportunityDetailsContainer
  const modalsWithKeys: Partial<Record<string, ReactNode>> = {
    [ModalsKeys.SyncDealInfoDialog]: <SyncDealInfoDialog vo={vo} externalDealId={externalDealId} />,
  };

  return (
    <>
      {render[pageContentViewType]}

      {/* Legacy Modal (CADMv1) */}
      <Modal
        open={openLegacyCreditAppModal}
        onClose={() => setOpenLegacyCreditAppModal(false)}
        aria-labelledby="Credit Application"
        aria-describedby="Summary"
      >
        <>
          {!!legacyPDFData && (
            <NewCreditAppModal
              {...legacyPDFData}
              {...vo}
              contactEmail={legacyPDFData.businessEmail}
              softPullInDealerPortal={vendorProfile.softPullInDealerPortal}
              refetchCreditApp={() => {}}
              handleRefetchCreditAppRequest={() => {}}
            />
          )}
        </>
      </Modal>

      <ModalsContainer modalsWithKeys={modalsWithKeys} />
    </>
  );
};

const mapStateToProps = (state: any) => ({
  account: state.account,
  userProfile: state.userProfile,
  vp: state.vp,
  refetch: state.refetch,
  chat: state.chat,
  creditApp: state.creditApp,
  refetchCreditApp: state.refetchCreditApp,
});

const mapDispatchToProps = {
  reduxSetValue: setValue,
  setRefetch,
};

export default connect(mapStateToProps, mapDispatchToProps)(PageOpportunityDetails);

const useStyles = makeStyles({
  pageContainer: {
    gap: '0.3rem',
    display: 'flex',
    flexDirection: 'column',
  },
  head: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    padding: '1.5rem 1.5rem 0.5rem 1.5rem',
  },
  headContent: {
    width: '100%',
    gap: '0.5rem',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    gap: '1rem',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
  },
});
